import type { FactorRuleDisplay } from "../../types"

export interface CellConfig {
  id: string
  render: (rule: FactorRuleDisplay) => {
    content: string | number | undefined
    isClickable?: boolean
    isSelected?: boolean
  }
}

export const CELL_CONFIG: readonly CellConfig[] = [
  {
    id: "factor",
    render: (rule: FactorRuleDisplay) => ({
      content: rule.name,
    }),
  },
  {
    id: "current",
    render: (rule: Partial<FactorRuleDisplay>) => ({
      content: rule.value ?? "-",
      isClickable: Boolean(rule.activeValue !== undefined),
      isSelected: !rule.useActiveValue,
    }),
  },
  {
    id: "active",
    render: (rule: Partial<FactorRuleDisplay>) => ({
      content: rule.activeValue ?? "-",
      isClickable: Boolean(rule.activeValue !== undefined),
      isSelected: Boolean(rule.useActiveValue),
    }),
  },
] as const
